import { Component, Input, EventEmitter} from '@angular/core';


@Component({
  selector: 'calendar-day',
  template: `
              <div class="calendar-cont">
                <button class="done-btn" ion-button color="secondary" outline>{{ 'markThisDay' | translate }}</button>
                <div class="calendar-icon">
                  <img class="page-curl" src="assets/images/pageCurl.png" />
                  <span class="binds"></span>
                  <span class="month">{{ 'detox' | translate }}</span>
                  <h1 class="day">{{dayIndex}}</h1>
                </div>
              </div>
            `
})

export class CalendarDayComponent {
  @Input() dayIndex: number;
  // @Output('doneClick') doneClick = new EventEmitter<any>();
  // currentDayIndex: number = -1;

  constructor(){}

  // doneBtnClick() {
    // this.doneClick.emit();
  // }
}